import identity from "lodash/fp/identity";

class FulfillmentPlansPageTransform {
  constructor() {
    "ngInject";

    this.item = {
      title: "Fulfillment Plan",
      state: "fulfillmentplan",
    };

    this.filters = [
      {
        name: "search",
        title: "Search by name",
        icon: "search",
        isSearch: true,
        resource: "FulfillmentPlan",
        state: "fulfillmentplan",
        size: 30,
      },
      { name: "city", title: "City", icon: "location_city", resource: "City" },
    ];

    this.fields = [
      { title: "Plan Name", name: "name" },
      { title: "City", name: "city" },
    ];
  }

  justify(data) {
    return identity(data);
  }
}

export default FulfillmentPlansPageTransform;



// WEBPACK FOOTER //
// ./src/pages/fulfillmentPlans/fulfillmentPlans.transforms.js